export default "__VITE_ASSET__CDpp7NOP__"